import { getInstance } from './HttpClient';

export const UserApi = getInstance('https://api.truvadi.com');
